// (function () {
//   function initCartContactDetails() {
//     const igInput = document.getElementById('CartInstagramHandle');
//     const phoneInput = document.getElementById('CartMobileNumber');
//     const termsCheckbox = document.getElementById('CartAgreeTerms');
//     const errorMsg = document.getElementById('CartContactError');
//     const checkoutBtn = document.getElementById('CartDrawer-Checkout');

//     console.log('[CartContact] init', { igInput, phoneInput, termsCheckbox, checkoutBtn });

//     if (!igInput || !phoneInput || !termsCheckbox || !checkoutBtn) {
//       console.warn('[CartContact] Missing one or more elements — check IDs in cart-drawer.liquid');
//       return;
//     }

//     function updateButtonState() {
//       checkoutBtn.disabled = !termsCheckbox.checked;
//       console.log('[CartContact] checkbox checked:', termsCheckbox.checked, '-> button disabled:', checkoutBtn.disabled);
//     }

//     function saveCartAttributes() {
//       fetch('/cart/update.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           attributes: {
//             'Instagram Handle': igInput.value.trim(),
//             'Mobile Number': phoneInput.value.trim(),
//           },
//         }),
//       });
//     }

//     // Remove any old listeners by cloning (safe reset) — then attach fresh
//     termsCheckbox.addEventListener('change', updateButtonState);
//     igInput.addEventListener('blur', saveCartAttributes);
//     phoneInput.addEventListener('blur', saveCartAttributes);

//     checkoutBtn.addEventListener('click', function (e) {
//       const igValid = igInput.value.trim() !== '';
//       const phoneValid = phoneInput.value.trim() !== '';

//       if (!igValid || !phoneValid) {
//         e.preventDefault();
//         e.stopPropagation();
//         errorMsg.style.display = 'block';
//         if (!igValid) igInput.focus();
//         else if (!phoneValid) phoneInput.focus();
//         return false;
//       }
//       errorMsg.style.display = 'none';
//       saveCartAttributes();
//     });

//     // Set initial state
//     updateButtonState();
//   }

//   // Run on first load
//   document.addEventListener('DOMContentLoaded', initCartContactDetails);

//   // Re-run whenever the cart drawer content changes (Dawn re-renders it via fetch)
//   document.addEventListener('cart:refresh', initCartContactDetails);
//   document.addEventListener('cart:update', initCartContactDetails);

//   // Fallback: re-init if drawer element gets replaced — observe CartDrawer for changes
//   const observeTarget = document.getElementById('CartDrawer');
//   if (observeTarget) {
//     const observer = new MutationObserver(function () {
//       initCartContactDetails();
//     });
//     observer.observe(observeTarget, { childList: true, subtree: true });
//   } else {
//     // In case CartDrawer doesn't exist yet at script-load time, try again shortly
//     document.addEventListener('DOMContentLoaded', function () {
//       const el = document.getElementById('CartDrawer');
//       if (el) {
//         new MutationObserver(initCartContactDetails).observe(el, { childList: true, subtree: true });
//       }
//     });
//   }
// })();



// (function () {
//   function initCartContactDetails() {
//     const nameInput = document.getElementById('CartFullName');
//     const phoneInput = document.getElementById('CartMobileNumber');
//     const streetInput = document.getElementById('CartStreetAddress');
//     const suburbInput = document.getElementById('CartSuburb');
//     const stateInput = document.getElementById('CartState');
//     const postcodeInput = document.getElementById('CartPostcode');
//     const termsCheckbox = document.getElementById('CartAgreeTerms');
//     const errorMsg = document.getElementById('CartContactError');
//     const checkoutBtn = document.getElementById('CartDrawer-Checkout');

//     console.log('[CartContact] init', {
//       nameInput, phoneInput, streetInput, suburbInput, stateInput, postcodeInput, termsCheckbox, checkoutBtn
//     });

//     if (!nameInput || !phoneInput || !streetInput || !suburbInput || !stateInput || !postcodeInput || !termsCheckbox || !checkoutBtn) {
//       console.warn('[CartContact] Missing one or more elements — check IDs in cart-drawer.liquid');
//       return;
//     }

//     function updateButtonState() {
//       checkoutBtn.disabled = !termsCheckbox.checked;
//       console.log('[CartContact] checkbox checked:', termsCheckbox.checked, '-> button disabled:', checkoutBtn.disabled);
//     }

//     function getFullAddress() {
//       return [
//         streetInput.value.trim(),
//         suburbInput.value.trim(),
//         stateInput.value.trim(),
//         postcodeInput.value.trim(),
//       ].filter(Boolean).join(', ');
//     }

//     function saveCartAttributes() {
//       return fetch('/cart/update.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           attributes: {
//             'Name': nameInput.value.trim(),
//             'Mobile Number': phoneInput.value.trim(),
//             'Street Address': streetInput.value.trim(),
//             'Suburb': suburbInput.value.trim(),
//             'State': stateInput.value.trim(),
//             'Postcode': postcodeInput.value.trim(),
//             'Address': getFullAddress(),
//           },
//         }),
//       });
//     }

//     termsCheckbox.addEventListener('change', updateButtonState);
//     nameInput.addEventListener('blur', saveCartAttributes);
//     phoneInput.addEventListener('blur', saveCartAttributes);
//     streetInput.addEventListener('blur', saveCartAttributes);
//     suburbInput.addEventListener('blur', saveCartAttributes);
//     stateInput.addEventListener('blur', saveCartAttributes);
//     postcodeInput.addEventListener('blur', saveCartAttributes);

//     checkoutBtn.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();

//       const nameValid = nameInput.value.trim() !== '';
//       const phoneValid = phoneInput.value.trim() !== '';
//       const streetValid = streetInput.value.trim() !== '';
//       const suburbValid = suburbInput.value.trim() !== '';
//       const stateValid = stateInput.value.trim() !== '';
//       const postcodeValid = postcodeInput.value.trim() !== '';

//       if (!nameValid || !phoneValid || !streetValid || !suburbValid || !stateValid || !postcodeValid) {
//         errorMsg.style.display = 'block';
//         if (!nameValid) nameInput.focus();
//         else if (!phoneValid) phoneInput.focus();
//         else if (!streetValid) streetInput.focus();
//         else if (!suburbValid) suburbInput.focus();
//         else if (!stateValid) stateInput.focus();
//         else if (!postcodeValid) postcodeInput.focus();
//         return false;
//       }

//       errorMsg.style.display = 'none';

//       // Save attributes first, then redirect to checkout with the address pre-filled
//       saveCartAttributes().then(function () {
//         const params = new URLSearchParams({
//           'checkout[shipping_address][address1]': streetInput.value.trim(),
//           'checkout[shipping_address][city]': suburbInput.value.trim(),
//           'checkout[shipping_address][province]': stateInput.value.trim(),
//           'checkout[shipping_address][zip]': postcodeInput.value.trim(),
//           'checkout[shipping_address][country]': 'Australia',
//         });
//         window.location.href = '/checkout?' + params.toString();
//       }).catch(function (err) {
//         console.error('[CartContact] Failed to save attributes before checkout', err);
//         // Fall back to plain checkout redirect even if saving attributes failed
//         window.location.href = '/checkout';
//       });
//     });

//     updateButtonState();
//   }

//   document.addEventListener('DOMContentLoaded', initCartContactDetails);
//   document.addEventListener('cart:refresh', initCartContactDetails);
//   document.addEventListener('cart:update', initCartContactDetails);

//   const observeTarget = document.getElementById('CartDrawer');
//   if (observeTarget) {
//     const observer = new MutationObserver(function () {
//       initCartContactDetails();
//     });
//     observer.observe(observeTarget, { childList: true, subtree: true });
//   } else {
//     document.addEventListener('DOMContentLoaded', function () {
//       const el = document.getElementById('CartDrawer');
//       if (el) {
//         new MutationObserver(initCartContactDetails).observe(el, { childList: true, subtree: true });
//       }
//     });
//   }
// })();










(function () {
  function initCartContactDetails() {
    const nameInput = document.getElementById('CartFullName');
    const phoneInput = document.getElementById('CartMobileNumber');
    const igInput = document.getElementById('CartInstagramHandle');
    const streetInput = document.getElementById('CartStreetAddress');
    const suburbInput = document.getElementById('CartSuburb');
    const stateInput = document.getElementById('CartState');
    const postcodeInput = document.getElementById('CartPostcode');
    const termsCheckbox = document.getElementById('CartAgreeTerms');
    const errorMsg = document.getElementById('CartContactError');
    const checkoutBtn = document.getElementById('CartDrawer-Checkout');

    console.log('[CartContact] init', {
      nameInput, phoneInput, igInput, streetInput, suburbInput, stateInput, postcodeInput, termsCheckbox, checkoutBtn
    });

    if (!nameInput || !phoneInput || !igInput || !streetInput || !suburbInput || !stateInput || !postcodeInput || !termsCheckbox || !checkoutBtn) {
      console.warn('[CartContact] Missing one or more elements — check IDs in cart-drawer.liquid');
      return;
    }

    function updateButtonState() {
      checkoutBtn.disabled = !termsCheckbox.checked;
      console.log('[CartContact] checkbox checked:', termsCheckbox.checked, '-> button disabled:', checkoutBtn.disabled);
    }

    function getFullAddress() {
      return [
        streetInput.value.trim(),
        suburbInput.value.trim(),
        stateInput.value.trim(),
        postcodeInput.value.trim(),
      ].filter(Boolean).join(', ');
    }

    function saveCartAttributes() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Name': nameInput.value.trim(),
            'Mobile Number': phoneInput.value.trim(),
            'Instagram Handle': igInput.value.trim(),
            'Street Address': streetInput.value.trim(),
            'Suburb': suburbInput.value.trim(),
            'State': stateInput.value.trim(),
            'Postcode': postcodeInput.value.trim(),
            'Address': getFullAddress(),
          },
        }),
      });
    }

    termsCheckbox.addEventListener('change', updateButtonState);
    nameInput.addEventListener('blur', saveCartAttributes);
    phoneInput.addEventListener('blur', saveCartAttributes);
    igInput.addEventListener('blur', saveCartAttributes);
    streetInput.addEventListener('blur', saveCartAttributes);
    suburbInput.addEventListener('blur', saveCartAttributes);
    stateInput.addEventListener('blur', saveCartAttributes);
    postcodeInput.addEventListener('blur', saveCartAttributes);

    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const nameValid = nameInput.value.trim() !== '';
      const phoneValid = phoneInput.value.trim() !== '';
      const igValid = igInput.value.trim() !== '';
      const streetValid = streetInput.value.trim() !== '';
      const suburbValid = suburbInput.value.trim() !== '';
      const stateValid = stateInput.value.trim() !== '';
      const postcodeValid = postcodeInput.value.trim() !== '';

      if (!nameValid || !phoneValid || !igValid || !streetValid || !suburbValid || !stateValid || !postcodeValid) {
        errorMsg.style.display = 'block';
        if (!nameValid) nameInput.focus();
        else if (!phoneValid) phoneInput.focus();
        else if (!igValid) igInput.focus();
        else if (!streetValid) streetInput.focus();
        else if (!suburbValid) suburbInput.focus();
        else if (!stateValid) stateInput.focus();
        else if (!postcodeValid) postcodeInput.focus();
        return false;
      }

      errorMsg.style.display = 'none';

      // Save attributes first, then redirect to checkout with the address pre-filled
      saveCartAttributes().then(function () {
        const params = new URLSearchParams({
          'checkout[shipping_address][address1]': streetInput.value.trim(),
          'checkout[shipping_address][city]': suburbInput.value.trim(),
          'checkout[shipping_address][province]': stateInput.value.trim(),
          'checkout[shipping_address][zip]': postcodeInput.value.trim(),
          'checkout[shipping_address][country]': 'Australia',
        });
        window.location.href = '/checkout?' + params.toString();
      }).catch(function (err) {
        console.error('[CartContact] Failed to save attributes before checkout', err);
        // Fall back to plain checkout redirect even if saving attributes failed
        window.location.href = '/checkout';
      });
    });

    updateButtonState();
  }

  document.addEventListener('DOMContentLoaded', initCartContactDetails);
  document.addEventListener('cart:refresh', initCartContactDetails);
  document.addEventListener('cart:update', initCartContactDetails);

  const observeTarget = document.getElementById('CartDrawer');
  if (observeTarget) {
    const observer = new MutationObserver(function () {
      initCartContactDetails();
    });
    observer.observe(observeTarget, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      const el = document.getElementById('CartDrawer');
      if (el) {
        new MutationObserver(initCartContactDetails).observe(el, { childList: true, subtree: true });
      }
    });
  }
})();